import type { RotasDoModulo } from '@/app/rotas';

import { BanksPage, InsurersPage } from './CounterpartiesPage';

/** Contrapartes: seguradoras e bancos. */
export const rotas: RotasDoModulo = {
  menu: {
    '/seguradoras': InsurersPage,
    '/bancos': BanksPage,
  },
};
